"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
/* eslint-disable react-hooks/rules-of-hooks */
const pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const react_1 = tslib_1.__importDefault(require("react"));
const utils_1 = require("../../utils");
exports.OsmosysAppNavChevron = () => {
    return (react_1.default.createElement(utils_1.OsmosysDiv, { flexColCentered: true },
        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { className: "text-muted", style: { opacity: 0.6 }, icon: pro_light_svg_icons_1.faChevronRight })));
};
//# sourceMappingURL=Chevron.js.map